import {
  Identifiable,
  OptimizedTimeSheet,
  Project,
  Resource,
  TimeSheetFilter,
} from "@planzone/dto";
import { State } from "./types";

function areFiltersMatching(a: TimeSheetFilter, b: TimeSheetFilter) {
  return (
    a.minDate === b.minDate &&
    a.maxDate === b.maxDate &&
    a.includeCompletedTasks === b.includeCompletedTasks &&
    a.integrationScope === b.integrationScope
  );
}

function matchRequest(
  req: State[number],
  project: Identifiable<Project>,
  resource: Identifiable<Resource>,
  filter: TimeSheetFilter,
  size?: number,
): boolean {
  return (
    req.project.uuid === project.uuid &&
    req.resource.uuid === resource.uuid &&
    // (typeof size === "undefined" || req.size === size) &&
    areFiltersMatching(req.filter, filter)
  );
}

function mergeTS(
  source: OptimizedTimeSheet,
  target: OptimizedTimeSheet,
): OptimizedTimeSheet {
  return {
    ...target,
    spentTimes: source.spentTimes,
    elements: target.elements.map((targetElement) => {
      const sourceElement = source.elements.find(
        (e) => e.uuid === targetElement.uuid,
      );

      // If matching element found in source, replace spentTimes only
      if (sourceElement) {
        return {
          ...targetElement,
          spentTimes: sourceElement.spentTimes,
        };
      }

      // Otherwise keep as is
      return targetElement;
    }),
  };
}

export { matchRequest, mergeTS };
